export const headerMembers = [
  { key: "avatar", label: "Avatar" },
  { key: "member", label: "Member" },
  { key: "email", label: "Email" },
  { key: "action", label: "Action" },
];
